const _ = require('lodash')

class MediaQueryManager {
  constructor() {
    this.listeners = []
    this.listenerMap = new Map()
    this.mediaQueryLists = {}
    this.onMediaQueryChange = this.onMediaQueryChange.bind(this)
  }

  matches(key) {
    const mql = this.mediaQueryLists[key]
    if (!mql) {
      throw new Error(`MediaQueryManager key[${key}] does not exist`)
    }
    return mql.matches
  }

  onMediaQueryChange() {
    this.listeners.forEach(listener => {
      listener()
    })
  }

  addListener(callback) {
    if (this.listenerMap.has(callback)) {
      throw new Error('MediaQueryManager listener already exists')
    }
    const debounced = _.debounce(callback)
    this.listenerMap.set(callback, debounced)
    this.listeners.push(debounced)
  }

  removeListener(callback) {
    if (!this.listenerMap.has(callback)) {
      throw new Error('MediaQueryManager listener does not exist')
    }
    const debounced = this.listenerMap.get(callback)
    const listenerIndex = this.listeners.indexOf(debounced)
    this.listeners = this.listeners.splice(listenerIndex, 1)
    this.listenerMap.delete(callback)
  }

  addMediaQuery(key, mediaQueryString) {
    if (this.mediaQueryLists[key]) {
      throw new Error(`MediaQueryManager key[${key}] already exists`)
    }
    const mql = window.matchMedia(mediaQueryString)
    mql.addListener(this.onMediaQueryChange)
    this.mediaQueryLists[key] = mql
  }

  removeMediaQuery(key) {
    const mql = this.mediaQueryLists[key]
    if (!mql) {
      throw new Error(`MediaQueryManager key[${key}] does not exist`)
    }
    mql.removeListener(this.onMediaQueryChange)
    delete this.mediaQueryLists[key]
  }
}

const manager = module.exports = new MediaQueryManager()

const { mediaQueries } = require('./responsive')
Object.keys(mediaQueries).forEach(key => {
  manager.addMediaQuery(key, mediaQueries[key])
})
